import styles from './ToggleSwitch.module.css';

export default function ToggleSwitch({
  checked = false,
  onChange = () => {},
  disabled = false,
  height = 18,
  knobMargin = 2,
  onLabel = 'On',
  offLabel = 'Off',
  labelColor,
}) {
  const knobSize = height - knobMargin * 2;
  const width = height * 2;

  return (
    <label className={styles.switchWrapper}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      <span
        className={styles.slider}
        style={{
          width: `${width}px`,
          height: `${height}px`,
          '--knob-size': `${knobSize}px`,
          '--knob-translate': `${width - height}px`,
        }}
      ></span>
      <span className={styles.labelWrapper}>
        <span className={styles.status} style={{ color: labelColor }}>
          {checked ? onLabel : offLabel}
        </span>
      </span>
    </label>
  );
}
